<h1 mat-dialog-title i18n>Edit User Attributes <small class="align-top">- {{dialogData.user.email}}</small></h1>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()" class="user-edit-form">
	<div mat-dialog-content class="main-content mb-2">
		<div class="row">

			<div class="col-12">
				<mat-form-field appearance="standard" class="w-100 hover-suffix">
					<mat-label i18n>Zone 5 User ID</mat-label>
					<input matInput type="text" placeholder="-" i18n-placeholder value="{{ dialogData.user.id }}" disabled/>
					<button
						class="suffix-icon"
						mat-icon-button
						type="button"
						title="Copy to clipboard"
						[appCopyToClipboard]="dialogData.user.id"
						i18n-title
						matSuffix
					>
						<span class="material-icons">content_copy</span>
					</button>
				</mat-form-field>

				<mat-form-field appearance="standard" class="w-100 hover-suffix">
					<mat-label i18n>Email</mat-label>
					<input matInput type="text" placeholder="Email" i18n-placeholder value="{{dialogData.user.email}}" disabled />

					<mat-icon
						*ngIf="dialogData.user.validated"
						aria-hidden="false"
						aria-label="Verified icon showing tooltip"
						class="suffix-icon text-success"
						matTooltip="Email has been verified."
						i18n-matTooltip
						matSuffix
					>check_circle</mat-icon>
					<mat-icon
						*ngIf="!dialogData.user.validated"
						aria-hidden="false"
						aria-label="Verified icon showing tooltip"
						class="suffix-icon text-danger"
						matTooltip="Email has not been verified."
						i18n-matTooltip
						matSuffix
					>unpublished</mat-icon>
					<button
						class="suffix-icon"
						mat-icon-button
						type="button"
						title="Copy to clipboard"
						[appCopyToClipboard]="dialogData.user.email"
						i18n-title
						matSuffix
						*ngIf="dialogData.user.email"
					>
						<span class="material-icons">content_copy</span>
					</button>
				</mat-form-field>
			</div>
			<!-- END Email -->

			<!-- Account Status -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 hover-suffix" *ngIf="dialogData.user.suspended">
					<mat-label i18n>Account Status</mat-label>
					<input matInput type="text" i18n-placeholder i18n-value value="Suspended" disabled/>
					<mat-icon
						class="suffix-icon text-danger"
						matTooltip="This account is suspended and cannot log in."
						i18n-matTooltip
						matSuffix
					>unpublished</mat-icon>
				</mat-form-field>

				<mat-form-field appearance="standard" class="w-100 hover-suffix" *ngIf="!dialogData.user.suspended">
					<mat-label i18n>Account Status</mat-label>
					<input matInput type="text" i18n-placeholder i18n-value value="Active" disabled/>
					<mat-icon
						class="suffix-icon text-success"
						matTooltip="Account is active."
						i18n-matTooltip
						matSuffix
					>check_circle</mat-icon>
				</mat-form-field>
			</div>
			<!-- Account Status -->

			<div class="col-6"></div>

			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 hover-suffix">
					<mat-label i18n>Last Login</mat-label>
					<input matInput type="text" placeholder="-" i18n-placeholder value="{{dialogData.user.lastLogin ? formatDate(dialogData.user.lastLogin) : '-'}}" disabled/>
					<mat-icon
						class="suffix-icon"
						matTooltip="Date and time displayed using your browser's locale and timezone settings."
						i18n-matTooltip
						matSuffix
					>info</mat-icon>
				</mat-form-field>
			</div>

			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 hover-suffix">
					<mat-label i18n>Created</mat-label>
					<input matInput type="text" placeholder="-" i18n-placeholder value="{{dialogData.user.createdTime ? formatDate(dialogData.user.createdTime) : '-'}}" disabled/>
					<mat-icon
						class="suffix-icon"
						matTooltip="Date and time displayed using your browser's locale and timezone settings."
						i18n-matTooltip
						matSuffix
					>info</mat-icon>
				</mat-form-field>
			</div>

			<ng-container *ngFor="let identity of dialogData.user.identities | keyvalue">
				<div class="col-12">
					<mat-form-field appearance="standard" class="w-100 hover-suffix">
						<mat-label i18n><span class="text-capitalize">{{identity.key.toLowerCase()}}</span> UUID</mat-label>
						<input matInput type="text" placeholder="-" i18n-placeholder value="{{ identity.value }}" disabled/>
						<button
							class="suffix-icon"
							mat-icon-button
							type="button"
							title="Copy to clipboard"
							[appCopyToClipboard]="identity.value"
							i18n-title
							matSuffix
						>
							<span class="material-icons">content_copy</span>
						</button>
					</mat-form-field>
				</div>
			</ng-container>

			<div class="col-12" *ngIf="dialogData.user.clientId">
				<mat-form-field appearance="standard" class="w-100 hover-suffix">
					<mat-label i18n>Registration Source Client ID</mat-label>
					<input matInput type="text" placeholder="-" i18n-placeholder value="{{ dialogData.user.clientId }}" disabled/>
					<mat-icon
						matSuffix
						class="suffix-icon"
						aria-hidden="false"
						aria-label="icon displays a tooltip when focused or hovered over"
						matTooltip="The Client ID who originally registered this user account."
						i18n-matTooltip
					>info</mat-icon>
					<button
						class="suffix-icon"
						mat-icon-button
						type="button"
						title="Copy to clipboard"
						[appCopyToClipboard]="dialogData.user.clientId"
						i18n-title
						matSuffix
					>
						<span class="material-icons">content_copy</span>
					</button>
				</mat-form-field>
			</div>

			<!-- First Name -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 first-name-field">
					<mat-label i18n>First Name</mat-label>
					<input matInput type="text" placeholder="First Name" i18n-placeholder formControlName="firstname" [errorStateMatcher]="errorStateMatcher" maxlength="64"/>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.firstname"
						[type]="formEditorInputType.text"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END First Name -->

			<!-- Last Name -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 last-name-field">
					<mat-label i18n>Last Name</mat-label>
					<input matInput type="text" placeholder="Last Name" i18n-placeholder formControlName="lastname" [errorStateMatcher]="errorStateMatcher" maxlength="64"/>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.lastname"
						[type]="formEditorInputType.text"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Last Name -->

			<!-- Avatar -->
			<!-- URL http/https -->
			<div class="col-12">
				<mat-form-field appearance="standard" class="w-100">
					<mat-label i18n>Avatar</mat-label>
					<input matInput type="url" placeholder="Avatar" i18n-placeholder formControlName="avatar" [errorStateMatcher]="errorStateMatcher"/>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.avatar"
						[type]="formEditorInputType.url"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Avatar -->

			<div class="divider"></div>

			<!-- Metric -->
			<!-- metric or imperial - select -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 display-unit-field">
					<mat-label i18n>Display Units</mat-label>
					<mat-select formControlName="metric" [errorStateMatcher]="errorStateMatcher">
						<mat-option id="{{unit.id}}-option" [value]="unit.id" i18n *ngFor="let unit of units">{{unit.label}}</mat-option>
					</mat-select>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.metric"
						[type]="formEditorInputType.select"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Metric -->

			<div class="col-6"></div>

			<!-- Height -->
			<div class="col-6" *ngIf="this.formInputs.get('metric').value === 'metric'">
				<mat-form-field appearance="standard" class="w-100 metric-height-field">
					<mat-label i18n>Height</mat-label>
					<input matInput type="number" formControlName="height" min="0" [errorStateMatcher]="errorStateMatcher"/>
					<span class="text-secondary" matSuffix>cm</span>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.height"
						[type]="formEditorInputType.number"
					></mat-error>
				</mat-form-field>
			</div>

			<div class="col-3" *ngIf="this.formInputs.get('metric').value === 'imperial'">
				<mat-form-field appearance="standard" class="w-100" [floatLabel]="'always'">
					<mat-label i18n>Height</mat-label>
					<input matInput type="number" formControlName="heightFt" min="0" [errorStateMatcher]="errorStateMatcher"/>
					<span class="text-secondary" matSuffix>ft</span>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.heightFt"
						[type]="formEditorInputType.number"
					></mat-error>
				</mat-form-field>
			</div>

			<div class="col-3" *ngIf="this.formInputs.get('metric').value === 'imperial'">
				<mat-form-field appearance="standard" class="w-100">
					<input matInput type="number" formControlName="heightIn" min="0" [errorStateMatcher]="errorStateMatcher"/>
					<span class="text-secondary" matSuffix>in</span>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.heightIn"
						[type]="formEditorInputType.number"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Height -->

			<!-- Weight -->
			<div class="col-6" *ngIf="this.formInputs.get('metric').value === 'metric'">
				<mat-form-field appearance="standard" class="w-100 metric-weight-field">
					<mat-label i18n>Weight</mat-label>
					<input matInput type="number" placeholder="Weight" i18n-placeholder formControlName="weight" min="0" step="1" [errorStateMatcher]="errorStateMatcher"/>
					<span class="text-secondary" matSuffix>kg</span>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.weight"
						[type]="formEditorInputType.number"
					></mat-error>
				</mat-form-field>
			</div>

			<div class="col-6" *ngIf="this.formInputs.get('metric').value === 'imperial'">
				<mat-form-field appearance="standard" class="w-100">
					<mat-label i18n>Weight</mat-label>
					<input matInput type="number" placeholder="Weight" i18n-placeholder formControlName="weightLb" min="0" [errorStateMatcher]="errorStateMatcher"/>
					<span class="text-secondary" matSuffix>lb</span>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.weightLb"
						[type]="formEditorInputType.number"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Weight -->

			<!-- Gender -->
			<!-- String -->
			<!-- male, female, other, or notsay. -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 gender-field">
					<mat-label i18n>Gender</mat-label>
					<mat-select formControlName="gender" [errorStateMatcher]="errorStateMatcher">
						<mat-option value="" i18n>Please Select</mat-option>
						<mat-option id="{{gender.id}}" class="gender-field__option" [value]="gender.id" i18n *ngFor="let gender of genders">{{gender.label}}</mat-option>
					</mat-select>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.gender"
						[type]="formEditorInputType.select"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Gender -->

			<!-- DOB -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 dob-field">
					<mat-label>Date Of Birth</mat-label>
					<input matInput [matDatepicker]="dobDatePicker" formControlName="dob" i18n-placeholder placeholder="'DD/MM/YYYY'" [errorStateMatcher]="errorStateMatcher">
					<mat-datepicker-toggle matSuffix [for]="dobDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #dobDatePicker disabled="false"></mat-datepicker>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.dob"
						[type]="formEditorInputType.date"
					></mat-error>
				  </mat-form-field>
			</div>
			<!-- END DOB -->

			<div class="divider"></div>

			<!-- Timezone -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 timezone-field">
					<mat-label i18n>Time Zone</mat-label>
					<mat-select formControlName="timezone" (openedChange)="expandedTimezoneArea = ''" [errorStateMatcher]="errorStateMatcher">
						<mat-option value="" i18n>Please Select</mat-option>
						<mat-optgroup *ngFor="let timezoneArea of timezonesService.data.timezonesByArea | keyvalue">
							<button type="button" mat-flat-button (click)="toggleTimezoneGroup($event, timezoneArea.key)" [style.margin-left]="'-8px'">
								{{timezoneArea.key}}
								<span class="material-icons" *ngIf="expandedTimezoneArea !== timezoneArea.key">expand_more</span>
								<span class="material-icons" *ngIf="expandedTimezoneArea === timezoneArea.key">expand_less</span>
							</button>
							<mat-option id="{{timezone.id}}" class="timezone-field__option" *ngFor="let timezone of timezoneArea.value" [value]="timezone.id" [style.display]="expandedTimezoneArea === timezoneArea.key ? 'block' : 'none'">
								{{timezone.name}}
							</mat-option>
						</mat-optgroup>
					</mat-select>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.timezone"
						[type]="formEditorInputType.select"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Timezone -->

			<!-- Locale -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 locale-field">
					<mat-label i18n>Locale</mat-label>
					<mat-select formControlName="locale" [errorStateMatcher]="errorStateMatcher">
						<mat-option value="" i18n>Please Select</mat-option>
						<mat-option class="locale-field__option" id="{{locale.id}}" *ngFor="let locale of locales" [value]="locale.id">
							{{locale.label}}
						</mat-option>
					</mat-select>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.locale"
						[type]="formEditorInputType.select"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Locale -->

			<!-- Country -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 country-field">
					<mat-label i18n>Country</mat-label>
					<mat-select formControlName="country" [errorStateMatcher]="errorStateMatcher">
						<mat-option value="" i18n>Please Select</mat-option>
						<mat-option class="billing-country-field__option" id="{{c.id}}" [value]="c.id" i18n *ngFor="let c of countries">{{c.label}}</mat-option>
                    </mat-select>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.country"
						[type]="formEditorInputType.text"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Country -->

			<!-- State -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 state-field">
					<mat-label i18n>State</mat-label>
					<input matInput type="text" placeholder="i.e. NSW" i18n-placeholder formControlName="state" [errorStateMatcher]="errorStateMatcher" maxlength="255" />
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.state"
						[type]="formEditorInputType.text"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END State -->

			<!-- Locality -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 locality-field">
					<mat-label i18n>Locality</mat-label>
					<input matInput type="text" placeholder="i.e. Sydney" i18n-placeholder formControlName="locality" [errorStateMatcher]="errorStateMatcher" maxlength="255" />
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.locality"
						[type]="formEditorInputType.text"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Locality -->

			<!-- Billing Country -->
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100 billing-country-field">
					<mat-label i18n>Billing Country</mat-label>
					<mat-select formControlName="billingCountry" [errorStateMatcher]="errorStateMatcher">
						<mat-option value="" i18n>Please Select</mat-option>
						<mat-option class="billing-country-field__option" id="{{c.id}}" [value]="c.id" i18n *ngFor="let c of countries">{{c.label}}</mat-option>
					</mat-select>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.country"
						[type]="formEditorInputType.select"
					></mat-error>
				</mat-form-field>
			</div>
			<!-- END Billing Country -->

			<!-- Addresses -->
			<div class="col-12 mb-4 mt-2">
				<div class="custom-table addresses-table" formGroupName="addresses">
					<div class="row custom-table-header">
						<div class="col align-self-center">
							<span class="title">Addresses</span>
						</div>
						<!-- MENU -->
						<div class="col-xs-auto action-btn mr-1">
							<button class="addresses-table__add" mat-icon-button type="button" (click)="addAddress()" i18n-title title="Add address">
								<span class="material-icons">add_circle_outline</span>
							</button>
						</div>
					</div>

					<div
						class="row align-items-center mx-0 custom-table-body"
						*ngFor="let address of addresses | keyvalue"
					>
						<div class="col mx-auto px-0 form-field">
							<mat-form-field appearance="standard" class="w-100 col-6 addresses-table__type-field">
								<mat-label i18n>Type</mat-label>
								<input matInput type="text" placeholder="Type" i18n-placeholder formControlName="{{address.key}}Type" [errorStateMatcher]="errorStateMatcher"/>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('addresses').get(address.key + 'Type')"
									[type]="formEditorInputType.text"
								></mat-error>
							</mat-form-field>

							<div class="w-100"></div>

							<mat-form-field appearance="standard" class="w-100 col-12 addresses-table__street-field">
								<mat-label i18n>Street</mat-label>
								<input matInput type="text" placeholder="Street" i18n-placeholder formControlName="{{address.key}}Street" [errorStateMatcher]="errorStateMatcher"/>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('addresses').get(address.key + 'Street')"
									[type]="formEditorInputType.text"
								></mat-error>
							</mat-form-field>

							<mat-form-field appearance="standard" class="w-100 col-6 addresses-table__city-field">
								<mat-label i18n>City</mat-label>
								<input matInput type="text" placeholder="City" i18n-placeholder formControlName="{{address.key}}City" [errorStateMatcher]="errorStateMatcher"/>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('addresses').get(address.key + 'City')"
									[type]="formEditorInputType.text"
								></mat-error>
							</mat-form-field>

							<mat-form-field appearance="standard" class="w-100 col-6 addresses-table__zip-field">
								<mat-label i18n>Postal Code</mat-label>
								<input matInput type="text" placeholder="Postal Code" i18n-placeholder formControlName="{{address.key}}Zip" [errorStateMatcher]="errorStateMatcher"/>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('addresses').get(address.key + 'Zip')"
									[type]="formEditorInputType.text"
								></mat-error>
							</mat-form-field>

							<mat-form-field appearance="standard" class="w-100 col-6 addresses-table__state-field">
								<mat-label i18n>State</mat-label>
								<input matInput type="text" placeholder="State" i18n-placeholder formControlName="{{address.key}}State" [errorStateMatcher]="errorStateMatcher"/>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('addresses').get(address.key + 'State')"
									[type]="formEditorInputType.text"
								></mat-error>
							</mat-form-field>

							<mat-form-field appearance="standard" class="w-100 col-6 addresses-table__country-field">
								<mat-label i18n>Country</mat-label>
								<mat-select formControlName="{{address.key}}Country" [errorStateMatcher]="errorStateMatcher">
									<mat-option value="" i18n>Please Select</mat-option>
									<mat-option class="addresses-table__option" id="{{c.id}}" [value]="c.id" i18n *ngFor="let c of countries">{{c.label}}</mat-option>
								</mat-select>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('addresses').get(address.key + 'Country')"
									[type]="formEditorInputType.select"
								></mat-error>
							</mat-form-field>

						</div>
						<div class="col-xs-auto edit-btn">
							<button
								mat-icon-button
								type="button"
								class="text-danger addresses-table__delete"
								(click)="deleteAddress(address)"
								title="Delete address"
								i18n-title
							>
								<span class="material-icons">delete_outline</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<!-- END Addresses -->

			<!-- TNS -->
			<div class="col-12 mb-4">
				<div class="custom-table tns-table" formGroupName="tns">
					<div class="row custom-table-header">
						<div class="col align-self-center">
							<span class="title">Phone Numbers</span>
						</div>
						<!-- MENU -->
						<div class="col-xs-auto action-btn mr-1">
							<button class="tns-table__add" mat-icon-button type="button" (click)="addPhoneNumber()" i18n-title title="Add phone number">
								<span class="material-icons">add_circle_outline</span>
							</button>
						</div>
					</div>

					<div
						class="row align-items-center mx-0 custom-table-body"
						*ngFor="let number of phoneNumbers | keyvalue"
					>
						<div class="col mx-auto form-field">
							<mat-form-field appearance="standard" class="w-100 tns-table__type-field">
								<mat-label i18n>Type</mat-label>
								<input matInput type="text" placeholder="Type" i18n-placeholder formControlName="{{number.key}}Type" [errorStateMatcher]="errorStateMatcher"/>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('tns').get(number.key + 'Type')"
									[type]="formEditorInputType.text"
								></mat-error>
							</mat-form-field>
						</div>
						<div class="col mx-auto form-field">
							<mat-form-field appearance="standard" class="w-100 tns-table__phone-field">
								<mat-label i18n>Phone Number</mat-label>
								<input matInput type="tel" placeholder="+1123456789" i18n-placeholder formControlName="{{number.key}}Value" [errorStateMatcher]="errorStateMatcher"/>
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.get('tns').get(number.key + 'Value')"
									[type]="formEditorInputType.tel"
								></mat-error>
							</mat-form-field>
						</div>
						<div class="col-xs-auto edit-btn">
							<button
								mat-icon-button
								type="button"
								class="text-danger tns-table__delete"
								(click)="deletePhoneNumber(number)"
								title="Delete phone number"
								i18n-title
							>
								<span class="material-icons">delete_outline</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<!-- END TNS -->

			<div class="divider"></div>

			<!-- Preference Mask -->
			<div class="col-12">
				<label class="w-100 mb-2 form-field-label" i18n>User Preferences</label>
				<ul class="list-unstyled checkbox-list prefs-mask-list">
					<li><mat-checkbox
						formControlName="ccpa"
						i18n
						color="primary"
					>Do not sell the user's data as per California Consumer Privacy Act legislation</mat-checkbox></li>
				</ul>
			</div>
			<!-- END Preference Mask -->

			<!-- User Marketing Comms Opt In -->
			<div class="col-12">
				<label class="w-100 mb-2 form-field-label" i18n>User Marketing Communications Opt In</label>
				<ul class="list-unstyled checkbox-list optin-mask-list">
					<li><mat-checkbox
						formControlName="mff"
						i18n
						color="primary"
					>MFF</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="roval"
						i18n
						color="primary"
					>Roval</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="specialized"
						i18n
						color="primary"
					>Specialized.com</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="retul"
						i18n
						color="primary"
					>Retul</mat-checkbox></li>
					<li><mat-checkbox
                        formControlName="app"
                        i18n
                        color="primary"
                    >Specialized App</mat-checkbox></li>
				</ul>
			</div>
			<!-- END User Marketing Comms Opt In -->

			<!-- Riding Preferences -->
			<div class="col-12">
				<label class="w-100 mb-2 form-field-label" i18n>User Riding Preferences</label>
				<ul class="list-unstyled checkbox-list ride-mask-list">
					<li><mat-checkbox
						formControlName="mountain"
						i18n
						color="primary"
					>Mountain</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="road"
						i18n
						color="primary"
					>Road</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="fitness"
						i18n
						color="primary"
					>Fitness</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="adventureOrTour"
						i18n
						color="primary"
					>Adventure or tour</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="dirtOrPark"
						i18n
						color="primary"
					>Dirt or park</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="cyclocross"
						i18n
						color="primary"
					>Cyclocross</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="casualOrCommute"
						i18n
						color="primary"
					>Casual or commute</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="downhill"
						i18n
						color="primary"
					>Downhill</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="triathlon"
						i18n
						color="primary"
					>Triathlon</mat-checkbox></li>
					<li><mat-checkbox
						formControlName="pedalAssist"
						i18n
						color="primary"
					>Pedal assist</mat-checkbox></li>
				</ul>
			</div>
			<!-- END Riding Preferences -->
		</div>
	</div>

	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
				cdkFocusInitial
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				[disabled]="!formInputs.valid"
				i18n
				cdkFocusInitial
			>Save</button>
		</div>
	</div>
</form>
